// extracted by mini-css-extract-plugin
module.exports = {"header":"_1cc45a8","body":"_bd54707"};